const DelayIcon = ({ className = '' }: { className?: string }) => (
  <svg
    width='120'
    height='120'
    viewBox='0 0 120 120'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <circle
      cx='60.2262'
      cy='60.2077'
      r='47.3268'
      fill='#FFCC3E'
      stroke='#FFE05F'
      strokeWidth='3'
    />
    <path
      d='M76.4697 74.3331L60.063 64.5465V43.4531'
      stroke='white'
      strokeWidth='4'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M82.2131 39.7868C93.9289 51.5025 93.9289 70.4975 82.2131 82.2131C70.4974 93.9289 51.5025 93.9289 39.7868 82.2131C28.0711 70.4974 28.0711 51.5025 39.7868 39.7868C51.5025 28.0711 70.4975 28.0711 82.2131 39.7868'
      stroke='white'
      strokeWidth='4'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <circle
      cx='60'
      cy='60'
      r='59'
      stroke='#FFE05F'
      strokeWidth='2'
      strokeDasharray='4 4'
    />
  </svg>
)

export default DelayIcon
